/**!
 * Apricot D8
 * @version 2
 * @author Mitra Assadi
 * @license
 * Copyright (c) 2023 The College Board
 */

/* ========================================================================
 * Apricot's D8
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-d8.scss";

// javaScript
import Utils from "./CBUtils";

/**
 * Menu Page Layout
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @returns {{destroy: Function}}
 */
 const menuPageLayout = (data = {}) => {
  const defaultData = {
    elem: null,
  };

  data = {
    ...defaultData,
    ...data,
  };

  let elem = data.elem;

  if (!Utils.elemExists(elem)) return null;


  const init = () => {
    elem.menuPageLayout = "cb";

    checkLayout(Utils.viewport().prefix);
    Utils.breakpoints();
    document.addEventListener("apricot_breakpointChange", breakpointChange);
  };

  const breakpointChange = (e) => {
    const data = e.data;

    checkLayout(data.prefix);
  };

  const chunkArray = (arr, chunk) => {
    let results = [];

    while (arr.length) {
      results.push(arr.splice(0, chunk));
    }

    return results;
  };

  const checkLayout = (viewport) => {
    let columns = 3;
    if (viewport === "xs") {
      columns = 1;
    } else if (viewport === "sm") {
      columns = 2;
    }

    const menus = [];
    elem.querySelectorAll(".cb-menu-list-d9 .cb-menu-list-heading-link, .cb-menu-list-d9 .cb-menu-list-heading").forEach((elem) => {
      elem.style.height = "auto";
      elem.style.minHeight = "auto";

      if (columns > 1) {
        const obj = {};
        obj.height = Utils.outerHeight(elem);
        obj.elem = elem;
        menus.push(obj);
      }
    });

    if (columns === 1) return;

    let items = chunkArray(menus, columns);

    for (var item in items) {
      const row = items[item];
      row.sort((a, b) => {
        return a.height - b.height;
      });

      const max = row[row.length - 1].height;

      Array.prototype.forEach.call(row, (obj) => {
        obj.elem.style.minHeight = `${max}px`;
        obj.elem.style.height = `${max}px`;
      });
    }
  };

  const destroy = () => {
    if (elem.menuPageLayout === "cb") {
      elem.menuPageLayout = null;
    }

    document.removeEventListener("apricot_breakpointChange", breakpointChange);
  };

  if (elem.menuPageLayout !== "cb") {
    init();
  }

  return {
    destroy: destroy,
  };
};

const CBApricotD8 = {
  menuPageLayout,
};


window.cb = window.cb || {};
window.cb.apricot = window.cb.apricot || {};
window.cb.apricot.CBApricotD8 = CBApricotD8;

export default CBApricotD8;